import React from 'react';

import NwIcon from '@components/Gui/NwIcon';

import {
    getUploadEmbedProvider,
    getUploadThumbnailUrl,
    isUploadDocument,
    isUploadEncodingVideo,
    isUploadLinkedVideo,
    isUploadVideo,
} from '@containers/Art/Uploads/UploadsRepository';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const getUploadPreviewIcon = (upload) => {
    const embedProvider = getUploadEmbedProvider(upload);
    if (embedProvider === 'youtube') return byPrefixAndName.fab['youtube'];
    if (embedProvider === 'vimeo') return byPrefixAndName.fab['vimeo'];
    return byPrefixAndName.fass['play'];
};

const UploadTilePreview = ({ upload }) => {
    const thumbnailUrl = getUploadThumbnailUrl(upload);

    if (isUploadDocument(upload)) {
        return <NwIcon icon={byPrefixAndName.fasl['file-pdf']} size="3x" />;
    }

    if (isUploadEncodingVideo(upload)) {
        return (
            <div className="upload-tile-encoding">
                <h1>Encoding video</h1>
                <small>Please wait...</small>
                <NwIcon icon={byPrefixAndName.fasl['camera-movie']} beat />
            </div>
        );
    }

    if (thumbnailUrl) {
        if (isUploadVideo(upload)) {
            return (
                <>
                    <img alt={upload.Title} src={thumbnailUrl} />
                    <span className="media-video-icon">
                        <NwIcon icon={getUploadPreviewIcon(upload)} />
                    </span>
                </>
            );
        }

        return <img alt={upload.Title} src={thumbnailUrl} />;
    }

    return (
        <NwIcon
            icon={
                isUploadVideo(upload)
                    ? isUploadLinkedVideo(upload)
                        ? getUploadPreviewIcon(upload)
                        : byPrefixAndName.fasl['film']
                    : byPrefixAndName.fasl['image']
            }
        />
    );
};

export default UploadTilePreview;
